/**
 * DeliveryAddressOption
 * @author ftgibran
 */
export enum DeliveryAddressOption {
  RECEIVER_ADDRESS = 'RECEIVER_ADDRESS',
  ANOTHER_ADDRESS = 'ANOTHER_ADDRESS',
}
